<script setup lang="ts">
import { useTranslate } from "@/composables/useTranslate";
import { defineEmits, defineProps } from "vue";
import SpinnerLoader from "../Loaders/SpinnerLoader.vue";

defineProps<Props>();
type Props = {
  isModalOpen: boolean;
  isLoading: boolean;
  isDeleteNote: boolean;
  text: any;
};

const emits = defineEmits<Emits>();
type Emits = {
  (event: "onClose"): void;
  (event: "onImageDelete"): void;
  (event: "onCommentDelete"): void;
};

const { t } = useTranslate();
</script>

<template>
  <Transition name="fade">
    <div
      v-show="isModalOpen"
      class="fixed top-0 right-0 bottom-0 left-0 z-[999] flex items-center justify-center w-full bg-black/80"
    >
      <Transition :name="!isDeleteNote ? 'slide' : ''">
        <div
          v-if="isModalOpen"
          class="bg-white w-full max-w-[361px] py-4 px-5 rounded-primary-radius"
        >
          <div class="w-full flex flex-col items-center">
            <img src="@/assets/focus-mode-delete-frame.svg" alt="Delete" />
            <span
              class="text-primary-text-color font-semibold text-xl leading-8 tracking-[0.01rem] text-center pt-2 pb-8"
              >{{ text }}</span
            >
          </div>
          <!-- Footer -->
          <div class="w-full flex items-center justify-end gap-4">
            <button
              @click="emits('onClose')"
              class="w-full max-w-[150px] h-[44px] px-3 rounded-primary-radius bg-white border-2 border-primary-text-color leading-5 tracking-[0.01rem] font-semibold"
            >
              {{ t("global.cancel") }}
            </button>
            <button
              @click="
                isDeleteNote ? emits('onCommentDelete') : emits('onImageDelete')
              "
              class="w-full max-w-[150px] h-[44px] px-3 rounded-primary-radius border-2 border-primary-text-color bg-primary-text-color text-white text-base leading-5 tracking-[0.01rem] font-semibold"
            >
              <div v-if="isLoading" class="flex items-center justify-center">
                <SpinnerLoader />
              </div>
              <span v-else>{{ t("global.delete") }}</span>
            </button>
          </div>
        </div>
      </Transition>
    </div>
  </Transition>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.slide-enter-active {
  transition: transform 0.5s ease;
}

.slide-leave-active {
  transition: transform 0.8s ease;
}

.slide-enter-from,
.slide-leave-to {
  transform: translateY(1000px);
}

.slide-enter-to,
.slide-leave-from {
  transform: translateY(0);
}
</style>
